export default __webpack_public_path__ + "static/media/university.c8901ebe.png";